import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

// components
import { PriceAmount } from './PriceAmount';

// helpers
import { getAmountByCurrency } from './helpers';
import get from 'lodash.get';

/**
 * Price Components for an item on sale
 *  (Sale or Sale & Original)
 */
export function SaleItemPrices({ showOriginal, currency, pricing, quantityDisplay }) {
    const { salePrice, saleOriginPrice } = pricing;
    const saleAmount = getAmountByCurrency(salePrice, currency);
    const originalAmount = showOriginal && getAmountByCurrency(saleOriginPrice, currency);

    let discount;
    if (originalAmount && saleAmount) {
        discount = get(pricing, 'percentageOff.salePrice');
    }

    return (
        <Fragment>
            {/* SALE PRICE */}
            <PriceAmount
                type="SALE"
                currency={currency}
                amount={saleAmount}
                quantityDisplay={quantityDisplay}
            />
            {/* ORIGINAL PRICE */}
            {!!originalAmount && (
                <PriceAmount
                    hasSalePrice
                    discount={discount}
                    currency={currency}
                    amount={originalAmount}
                    quantityDisplay={quantityDisplay}
                />
            )}
        </Fragment>
    );
}

SaleItemPrices.propTypes = {
    showOriginal: PropTypes.bool.isRequired,
    currency: PropTypes.string,
    quantityDisplay: PropTypes.string,
    pricing: PropTypes.shape({
        saleOriginPrice: PropTypes.object,
        salePrice: PropTypes.object.isRequired,
    }).isRequired,
};
